import React from 'react';
import SidebarNav from './SidebarNav';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const OffcanvasMenu = ({ menuItems, activeItemText }) => {
    const { logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        console.log('Logging out...')
        logout();
        navigate('/login');
    };

    return (
        <div className="offcanvas offcanvas-start bg-white" tabIndex="-1" id="offcanvasSidebar" aria-labelledby="offcanvasSidebarLabel">
            <div className="offcanvas-header">
                <h5 className="offcanvas-title" id="offcanvasSidebarLabel">Menú</h5>
                <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div className="offcanvas-body d-flex flex-column">
                <SidebarNav menuItems={menuItems} activeItemText={activeItemText} />
                <div className="offcanvas-footer mt-auto"> {/* Ensure footer is at the bottom */}
                    {/* Empty div as in original HTML, or add content if needed */}
                </div>
                <button className="btn btn-checkin px-3 w-100 mb-4" onClick={handleLogout}>Cerrar sesión</button>
            </div>
        </div>
    );
};

export default OffcanvasMenu;